export const API_URL = 'https://restcountries.com'
